export default {"src":"/_next/static/media/MXFlag.b6911111.svg","height":24,"width":32};